import {
  checkBadgeIcon,
  downloadIcon,
} from "../../assets/svgs/icons/icons.svg";
import BreadCrumbNavbar from "../../components/BreadCrumbNavbar/BreadCrumbNavbar";
import ContactSection from "../../components/ContactSection/ContactSection";
import Button from "../../components/global/Button/Button";
import LinkButton from "../../components/global/Button/LinkButton/LinkButton";
import InscriptionRecapInfoPersonnelles from "../../components/InscriptionRecapInfoPersonnelles/InscriptionRecapInfoPersonnelles";
import InscriptionRecapParticipation from "../../components/InscriptionRecapParticipation/InscriptionRecapParticipation";

import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import styles from "./InscriptionDemandeEnvoyeePage.module.scss";

export default function InscriptionDemandeEnvoyeePage() {
  const { t } = useTranslation();

  // * react-to-print
  const componentToPrintRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });

  return (
    <article className={styles.inscriptionDemandeEnvoyeePageContainer}>
      <BreadCrumbNavbar step="demande-envoyee" returnTo="/inscription/recapitulatif" />
      <article className={styles.inscriptionDemandeEnvoyeePage}>
        <header className={styles.inscriptionDemandeEnvoyeePage__header}>
          <div className={styles.inscriptionDemandeEnvoyeePage__header__top}>
            {checkBadgeIcon}
            <h1>{t("requestSent.title")}</h1>
          </div>
          <section
            className={styles.inscriptionDemandeEnvoyeePage__header__text}
          >
            <p>{t("requestSent.confirmation")}</p>
            <p>{t("requestSent.emailSent")}</p>
            <br />
            <p>{t("requestSent.modifyWarning1")}</p>
            <p>{t("requestSent.modifyWarning2")}</p>
            <p><a type="button" href="/flyer.pdf" target="_blank" >{t("requestSent.download")}</a></p>
          </section>
        </header>
        <main ref={componentToPrintRef} className={styles.inscriptionDemandeEnvoyeePage__main}>
          <InscriptionRecapInfoPersonnelles hasModifierButton={false} />
          <InscriptionRecapParticipation hasModifierButton={false} />
          <ContactSection />
        </main>
        <footer className={styles.inscriptionDemandeEnvoyeePage__footer}>
          <Button
            text={t("buttons.download")}
            buttonBackGroundColor="white"
            textColor="blue"
            customBorderColor="blue"
            icon={downloadIcon}
            onClick={handlePrint}
          />
        </footer>
      </article>
      <nav className={styles.inscriptionDemandeEnvoyeePage__navButton}>
        <LinkButton text={t("buttons.backToHomePage")} to="/" />
      </nav>
    </article>
  );
}
